import { BaseApiParams } from '@24i/nxg-core-utils/src/api';
import { Asset, getIsNewsSeries, getIsPodcastSeries, PlayerDataClient } from '@24i/nxg-sdk-photon';
import { BackstageApiBase } from '../../base';

export class BackstagePlayerDataClient extends BackstageApiBase implements PlayerDataClient {
    assetHasPlaybackAction = (asset: Asset, epgType: number) => {
        if (!asset) {
            return false;
        }

        const isMovie = asset.type === 'movie';
        const isSeries = asset.type === 'series';
        const isNewsSeries = getIsNewsSeries(asset);
        const isEpisode = asset.type === 'episode';
        const isEpgLive = asset.type === 'epg' && asset.isLive;
        const isChannel = asset.type === 'channel';
        const isPodcastSeries = getIsPodcastSeries(asset);
        const hasCatchup = epgType === 1 && asset.enableCatchUp;

        const isLive =
            (asset.type === 'broadcast' || asset.type === 'live_event') &&
            asset.start &&
            asset.start < Date.now() &&
            asset.end &&
            asset.end > Date.now();

        const isInProgress = asset.isLive && (asset.progress ?? 0) > 0 && (asset.progress ?? 0) < 1;

        return (
            (isMovie ||
                isSeries ||
                isNewsSeries ||
                isPodcastSeries ||
                hasCatchup ||
                isEpgLive ||
                isChannel ||
                isLive ||
                isInProgress ||
                isEpisode) ??
            false
        );
    };
}

export const createBackstagePlayerDataClient = (params: BaseApiParams) =>
    new BackstagePlayerDataClient(params);
